import { Box, Typography } from "@mui/material";

export default function Instruction({title, text, spanText, children}) {
  return (
    <Box sx={{
        py:"20px",
        borderBottom: "solid",
        borderBottomWidth:"16px",
        borderRadius:"15px",
        borderColor:"#000038"
    }}>
            <Typography variant="h4" sx={{
                py:"20px",
                fontWeight:"bold"
            }}>
                {title}
            </Typography>
            <Typography variant="p">
            <Typography variant="span" sx={{fontWeight:"bold"}}>{spanText} {" "}</Typography>
                {text}
            </Typography>
            {children}
        </Box>
  )
}
